const MetaTags = () => {

  if (!import.meta.env.PROD) {
    return <meta name="robots" content="noindex, nofollow" />;
  }

  return null;
};

export default MetaTags;
